/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

// TODO: To be removed with jpd-enable-roadmaps-recents-fe
type AsyncActionButtonsComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const asyncActionButtons: EntryPoint<AsyncActionButtonsComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<AsyncActionButtonsComponent>(
		/* webpackChunkName: "async-roadmaps-actions-buttons-entrypoint" */ './AsyncActionButtons.tsx',
	),
	getPreloadProps: () => ({}),
});
